import { render } from "./BaccaratView.vue?vue&type=template&id=18d6bb59&scoped=true"
import script from "./BaccaratView.vue?vue&type=script&lang=js"
export * from "./BaccaratView.vue?vue&type=script&lang=js"

import "./BaccaratView.vue?vue&type=style&index=0&id=18d6bb59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d6bb59"]])

export default __exports__